var _ellipse, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenTablecopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.103,
    cy: 16,
    rx: 16.103,
    ry: 16,
    fill: "#031737"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4206_438)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1159,
    height: 18,
    transform: "translate(7.04688 7)",
    fill: "#031737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8608 14.5V22.75C16.1085 22.75 12.8001 22.75 10.8215 22.75C9.98776 22.75 9.3125 22.0784 9.3125 21.25V10.75C9.3125 9.92157 9.9884 9.25 10.8222 9.25L21.3898 9.25C22.2235 9.25 22.8994 9.92157 22.8994 10.75V14.5H16.8608ZM15.3511 14.5H10.8222V17.5H15.3511V14.5ZM15.3511 21.25V19H10.8222V21.25H15.3511ZM16.8608 10.75V13H21.3898V10.75H16.8608ZM15.3511 10.75H10.8222V13H15.3511V10.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3898 22.75V20.5H19.1253V19H21.3898V16.75H22.8994V19H25.1639V20.5H22.8994V22.75H21.3898Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4206_438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1159,
    height: 18,
    fill: "white",
    transform: "translate(7.04688 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenTablecopy);
export default __webpack_public_path__ + "static/media/OpenTable copy.d16118a5bd2c5adf4aa2d505552f0df2.svg";
export { ForwardRef as ReactComponent };